// window.addEventListener("load", () => {
//   gsap.registerPlugin(ScrollTrigger);

//   // Hilicon Chipset Section Animations
//   gsap.from("#layers-nexora-os .top-content", {
//     opacity: 0,
//     y: 30,
//     scrollTrigger: {
//       trigger: "#layers-nexora-os .top-content",
//       start: "top 70%",
//       end: "top 20%",
//       scrub: true,
//     },
//   });

//   gsap.from("#hilsicon-chipset .section-text.mediumhide", {
//     opacity: 0,
//     y: 30,
//     scrollTrigger: {
//       trigger: "#hilsicon-chipset",
//       start: "center 60%",
//       end: "center 20%",
//       scrub: true,
//     },
//   });

//   gsap.from("#hilsicon-chipset img", {
//     opacity: 0,
//     y: 30,
//     scrollTrigger: {
//       trigger: "#hilsicon-chipset",
//       start: "center 60%",
//       end: "center 20%",
//       scrub: true,
//     },
//   });

//   // Animation Banner Section
//   gsap.from(".animation-banner .section-content", {
//     opacity: 0,
//     y: 30,
//     scrollTrigger: {
//       trigger: ".animation-banner",
//       start: "top 70%",
//       end: "top 30%",
//       scrub: true,
//       onUpdate: () => {
//         if (window.innerWidth > 750) {
//           ScrollTrigger.refresh();
//         }
//       },
//     },
//   });

//   // Founders View Section
//   gsap.from(".founders-view .content", {
//     opacity: 0,
//     y: 30,
//     scrollTrigger: {
//       trigger: ".founders-view",
//       start: "center 90%",
//       end: "center 50%",
//       scrub: true,
//     },
//   });

//   // Illuminate Banner Content Animation
//   gsap.from("#illuminate-banner .section-content", {
//     opacity: 0,
//     y: 30,
//     scrollTrigger: {
//       trigger: "#illuminate-banner",
//       start: "top 70%",
//       end: "top 20%",
//       scrub: true,
//     },
//   });

//   // Hilicon Chipset Banner Animation
//   gsap.to("#hilsicon-chipset .banner-normal-image", {
//     opacity: 0,
//     ease: "power3.out",
//     scrollTrigger: {
//       trigger: "#hilsicon-chipset .banner-normal-image",
//       start: "top center",
//       end: "bottom top",
//       scrub: true,
//       onEnter: () =>
//         gsap.to("#hilsicon-chipset .banner-bright-image", {
//           opacity: 1,
//           duration: 1,
//           ease: "power3.out",
//         }),
//       onLeaveBack: () =>
//         gsap.to("#hilsicon-chipset .banner-bright-image", {
//           opacity: 0,
//           duration: 1,
//           ease: "power3.out",
//         }),
//     },
//   });
// });
document.addEventListener('click', function (e) {
  const secondChild = e.target.closest('.product-icon-text-block > :nth-child(2)');

  if (secondChild) {
    window.location.href = '/pages/return-cancellation-policy';
  }
});

/*-----scroll to top starts-----*/
$(document).ready(function() {
  var $backToTop = $('#back-top');
  // Hide initially
  $backToTop.hide();
  // Show / hide on scroll
  $(window).on('scroll', function() {
    if ($(window).scrollTop() > 220) {
      $backToTop.stop(true, true).fadeIn(400);
    } else {
      $backToTop.stop(true, true).fadeOut(400);
    }
  });
  // Smooth scroll to top on click
  $backToTop.on('click', function(e) {
    e.preventDefault();
    $('html, body').stop(true, true).animate({
      scrollTop: 0
    }, 800, 'swing');
  });
});
/*-----scroll to top ends-----*/

//----404 page & cart page redirect to homepage----//
document.addEventListener("DOMContentLoaded", function() {
  var canonicalLink = document.querySelector('link[rel="canonical"]');
  if (canonicalLink.href.includes("404")) {
    window.location.href = "https://www.layers.shop/";
  }
  // if (canonicalLink.href == "https://www.layers.shop/cart") {
  //   window.location.href = "https://www.layers.shop/";
  // }
});
